module.exports = "<span ng-init=\"tit = row.facebook_interests.join(', ')\" title=\"{{tit}}\">{{tit}}</span>"